var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectOurTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 63,
    viewBox: "0 0 68 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-784 -4957)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 63,
    rx: 12,
    transform: "translate(784 4957)",
    fill: "#3488eb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(802 4970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.325,10.475A1.475,1.475,0,0,0,15.85,9h-.738a8.113,8.113,0,1,0,0,16.225h7.375a8.114,8.114,0,0,0,2.32-15.888,1.274,1.274,0,0,0-1.583,1.31v.076a1.84,1.84,0,0,0,1.231,1.615,5.163,5.163,0,0,1-1.968,9.936H15.113a5.163,5.163,0,0,1,0-10.325h.738A1.475,1.475,0,0,0,17.325,10.475Z",
    transform: "translate(-0.1 8.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.487,4a8.113,8.113,0,1,1,0,16.225H15.75a1.475,1.475,0,1,1,0-2.95h.737a5.163,5.163,0,0,0,0-10.325H9.113a5.163,5.163,0,0,0-1.968,9.936A1.839,1.839,0,0,1,8.375,18.5v.076a1.274,1.274,0,0,1-1.583,1.31A8.114,8.114,0,0,1,9.113,4Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectOurTeam);
export default __webpack_public_path__ + "static/media/connect-our-team.d4226518e647cd8a76774fdebce52df9.svg";
export { ForwardRef as ReactComponent };